const Success = function ({ width, height, color }) {
  return (
    <svg
      width={width ? width : "367"}
      height={height ? height : "367"}
      viewBox="0 0 367 367"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M183.667 366.995C232.291 366.995 278.915 347.682 313.307 313.307C347.682 278.916 366.995 232.291 366.995 183.667C366.995 135.043 347.682 88.4186 313.307 54.0266C278.916 19.6514 232.291 0.338623 183.667 0.338623C135.043 0.338623 88.4185 19.651 54.0264 54.0266C19.6512 88.4174 0.338379 135.043 0.338379 183.667C0.338379 232.291 19.6508 278.915 54.0264 313.307C88.4173 347.682 135.043 366.995 183.667 366.995ZM88.4945 188.495C94.9945 182.041 105.495 182.041 111.995 188.495L150.338 226.838L246.838 130.338C253.448 124.666 263.307 125.057 269.463 131.213C275.62 137.37 275.994 147.213 270.338 153.838L162.01 262.166H161.994C155.494 268.635 144.994 268.635 138.494 262.166L88.4943 212.166C85.338 209.041 83.5723 204.775 83.5723 200.338C83.5723 195.885 85.3379 191.635 88.4943 188.494L88.4945 188.495Z"
        fill="#54B0B3"
      />
    </svg>
  );
};

export default Success;
